module.exports = __webpack_public_path__ + "static/media/category17.32262187.png";